/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface FaxProviderData {
  recipient_fax_number: string;
  provider_fax_id?: string | null;
  provider_status?: string | null;
  pages?: number | null;
}
